export const APP_ROUTE = {
  APP: {
    ROOT: {
      path: '/',
      getHref: () => '/',
    },
  },

  AUTH: {
    ROOT: {
      path: 'auth',
      getHref: () => '/auth',
    },

    SIGN_IN: {
      path: 'sign-in',
      getHref: (redirectTo?: string | null) =>
        `/auth/sign-in${redirectTo ? `?redirectTo=${encodeURIComponent(redirectTo)}` : ''}`,
    },
  },

  ANALYTICS: {
    DASHBOARD: {
      path: 'dashboard',
      getHref: () => '/dashboard',
    },
  },

  SITE_SETTING: {
    ROOT: {
      path: 'site-settings',
      getHref: () => '/site-settings',
    },
  },

  COMPANY_INFO: {
    ROOT: {
      path: 'company-info',
      getHref: () => '/company-info',
    },
  },

  COMPANY_STAT: {
    LIST: {
      path: 'company-stats',
      getHref: () => '/company-stats',
    },
    CREATE: {
      path: 'company-stats/create',
      getHref: () => '/company-stats/create',
    },
    EDIT: {
      path: 'company-stats/:id/edit',
      getHref: (id: string) => `/company-stats/${id}/edit`,
    },
  },

  COMPANY_FEATURE: {
    LIST: {
      path: 'company-features',
      getHref: () => '/company-features',
    },
    CREATE: {
      path: 'company-features/create',
      getHref: () => '/company-features/create',
    },
    EDIT: {
      path: 'company-features/:id/edit',
      getHref: (id: string) => `/company-features/${id}/edit`,
    },
  },

  CLIENT: {
    LIST: {
      path: 'clients',
      getHref: () => '/clients',
    },
    CREATE: {
      path: 'clients/create',
      getHref: () => '/clients/create',
    },
    EDIT: {
      path: 'clients/:id/edit',
      getHref: (id: string) => `/clients/${id}/edit`,
    },
  },

  HERO_SLIDE: {
    LIST: {
      path: 'hero-slides',
      getHref: () => '/hero-slides',
    },
    CREATE: {
      path: 'hero-slides/create',
      getHref: () => '/hero-slides/create',
    },
    EDIT: {
      path: 'hero-slides/:id/edit',
      getHref: (id: string) => `/hero-slides/${id}/edit`,
    },
  },

  PRODUCT_CATEGORY: {
    LIST: {
      path: 'product-categories',
      getHref: () => '/product-categories',
    },
    CREATE: {
      path: 'product-categories/create',
      getHref: () => '/product-categories/create',
    },
    EDIT: {
      path: 'product-categories/:id/edit',
      getHref: (id: string) => `/product-categories/${id}/edit`,
    },
  },

  PRODUCT: {
    LIST: {
      path: 'products',
      getHref: () => '/products',
    },
    CREATE: {
      path: 'products/create',
      getHref: () => '/products/create',
    },
    EDIT: {
      path: 'products/:id/edit',
      getHref: (id: string) => `/products/${id}/edit`,
    },
  },

  BLOG_CATEGORY: {
    LIST: {
      path: 'blog-categories',
      getHref: () => '/blog-categories',
    },
    CREATE: {
      path: 'blog-categories/create',
      getHref: () => '/blog-categories/create',
    },
    EDIT: {
      path: 'blog-categories/:id/edit',
      getHref: (id: string) => `/blog-categories/${id}/edit`,
    },
  },

  BLOG_POST: {
    LIST: {
      path: 'blog-posts',
      getHref: () => '/blog-posts',
    },
    CREATE: {
      path: 'blog-posts/create',
      getHref: () => '/blog-posts/create',
    },
    EDIT: {
      path: 'blog-posts/:id/edit',
      getHref: (id: string) => `/blog-posts/${id}/edit`,
    },
  },

  CONTACT_MESSAGE: {
    LIST: {
      path: 'contact-messages',
      getHref: () => '/contact-messages',
    },
    DETAIL: {
      path: 'contact-messages/:id',
      getHref: (id: string) => `/contact-messages/${id}`,
    },
  },

  MEDIA: {
    LIST: {
      path: 'media',
      getHref: () => '/media',
    },
  },

  USER: {
    LIST: {
      path: 'users',
      getHref: () => '/users',
    },
    CREATE: {
      path: 'users/create',
      getHref: () => '/users/create',
    },
    EDIT: {
      path: 'users/:id/edit',
      getHref: (id: string) => `/users/${id}/edit`,
    },
  },

  ERROR: {
    NOT_FOUND: {
      path: '404',
      getHref: () => '/404',
    },
    FORBIDDEN: {
      path: '403',
      getHref: () => '/403',
    },
    MAINTENANCE: {
      path: 'maintenance',
      getHref: () => '/maintenance',
    },
  },

  ROUTE_NOT_FOUND: {
    path: '*',
    getHref: () => '*',
  },
} as const;
